import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah } from '../../utils/printHelper';
import { orderMembers } from '../../utils/voucherBatch';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';
import { Printer } from 'lucide-react';

export function VoucherBatchDialog({ batchCheck, batchKeterangan, batchMembers, batchSubmitting, handlePrintBatchVoucher, setBatchKeterangan, setShowBatchDialog, showBatchDialog }) {
  return (
    <Dialog open={showBatchDialog} onOpenChange={setShowBatchDialog}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Print Voucher Pembayaran Gabungan</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-slate-50 p-3 rounded-lg text-sm space-y-2">
            <p className="font-semibold">{batchMembers[0]?.supplier_name || '-'}</p>
            <p className="text-slate-500 text-xs">{batchMembers[0]?.company_name || '-'}</p>
            <div className="divide-y">
              {orderMembers(batchMembers).map((m) => (
                <div key={m.id} className="flex justify-between gap-3 py-1" data-testid={`voucher-batch-row-${m.id}`}>
                  <span className="font-mono text-xs">{m.voucher_number || '-'} / {m.invoice_number}</span>
                  <span className="font-mono text-xs">Rp {formatRupiah(invoiceAmounts(m).nilaiDibayarkan)}</span>
                </div>
              ))}
            </div>
            <div className="flex justify-between gap-3 pt-2 border-t font-semibold">
              <span>Total Dibayarkan</span>
              <span className="font-mono" data-testid="voucher-batch-total">
                Rp {formatRupiah(batchMembers.reduce((s, m) => s + invoiceAmounts(m).nilaiDibayarkan, 0))}
              </span>
            </div>
          </div>

          {batchCheck.errors.length > 0 && (
            <div className="space-y-1">
              {batchCheck.errors.map((e) => (
                <p key={e.code} className="text-xs text-red-700">{e.message}</p>
              ))}
            </div>
          )}
          {batchCheck.warnings.map((w) => (
            <p key={w.code} className="text-xs text-amber-700">{w.message}</p>
          ))}

          <div className="space-y-2">
            <Label>Keterangan Tambahan (Opsional)</Label>
            <textarea
              className="flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm uppercase"
              value={batchKeterangan}
              onChange={(e) => setBatchKeterangan(e.target.value.toUpperCase())}
              placeholder="MASUKKAN KETERANGAN TAMBAHAN..."
              data-testid="voucher-batch-keterangan"
            />
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => setShowBatchDialog(false)} className="flex-1">Batal</Button>
            <Button
              className="flex-1 bg-purple-600 hover:bg-purple-700"
              onClick={handlePrintBatchVoucher}
              disabled={batchSubmitting || !batchCheck.ok}
              data-testid="voucher-batch-confirm"
            >
              <Printer className="h-4 w-4 mr-2" />
              {batchSubmitting ? 'Memproses...' : 'Print Voucher Gabungan'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
